module.exports = __webpack_public_path__ + "img/plansChami .a713b42e.png";